// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2KR27","error":"Textarea_error__5Z33r","readonly":"Textarea_readonly__Xih6C","disabled":"Textarea_disabled__2kjkV"};